import React, { useState } from 'react';

import { Select } from 'antd';
import { Form } from '@ant-design/compatible';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Input from 'common/components/input';
import Modal from 'common/components/modal';
import { landlordSystemProvider } from 'common/constants/landlord';
import useStyles from '../../style';

const EditLandlordIntegration = ({
  visible,
  onCancel,
  form,
  landlord,
  updateLandlord,
  getLandlord,
}) => {
  const { systemProvider, systemProviderComment } = landlord;
  const { getFieldDecorator, validateFields, resetFields, getFieldValue } = form;

  const { t } = useTranslation();
  const classes = useStyles();

  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    onCancel();
    resetFields(['systemProvider', 'systemProviderComment', 'systemExternalId']);
  };

  const onOk = () => {
    validateFields((error, values) => {
      if (!error) {
        const { systemProvider, systemProviderComment, systemExternalId } = values;
        setLoading(true);
        updateLandlord(
          {
            id: landlord.id,
            systemProvider,
            systemExternalId,
            systemProviderComment,
          },
          () => {
            setLoading(false);
            onCancel();
            getLandlord();
          },
          () => {
            setLoading(false);
          },
        );
      }
    });
  };

  return (
    <>
      <Modal
        title={t('cms.landlord.invoice_info.landlord_integration.modal.title')}
        width={454}
        visible={visible}
        okText={t('cms.properties.edit.leave_alert.title')}
        cancelText={t('cms.landlord.modal.cancel.button')}
        wrapClassName={classes.modalWrapper}
        onCancel={handleCancel}
        onOk={onOk}
        cancelButtonProps={{
          className: 'ant-btn-cancel',
        }}
        okButtonProps={{
          loading,
          className: 'ant-btn-confirm',
        }}
      >
        <Form className={classes.formWrapper}>
          <Form.Item label={t('cms.landlord.detail.system_provider.label')}>
            {getFieldDecorator('systemProvider', {
              initialValue: landlord.systemProvider ? systemProvider.toUpperCase() : undefined,
            })(
              <Select
                placeholder={t('cms.landlord.modal.not_specific.placeholder')}
                disabled={landlord.systemExternalId}
              >
                <For of={landlordSystemProvider} each="option" index="index">
                  <Select.Option key={index} value={option}>
                    {t(`cms.landlord.modal.${option.toLowerCase()}.option`)}
                  </Select.Option>
                </For>
              </Select>,
            )}
          </Form.Item>

          <Form.Item label={t('cms.landlord.detail.system_provider_comment.label')}>
            {getFieldDecorator('systemProviderComment', {
              rules: [
                {
                  max: 150,
                  message: t('cms.landlord.modal.error.system_provider_comment'),
                },
              ],
              initialValue: systemProviderComment,
              validateTrigger: 'onBlur',
            })(<Input placeholder={t('cms.landlord.modal.system_provider_comment.placeholder')} />)}
          </Form.Item>

          <Form.Item label={t('cms.landlord.detail.system_external_id.label')}>
            {getFieldDecorator('systemExternalId', {
              initialValue: landlord.systemExternalId,
              validateTrigger: 'onBlur',
              rules: [
                {
                  validator: (_, __, callback) => {
                    if (!getFieldValue('systemProvider')) {
                      return callback(
                        t('cms.landlord.detail.system_external_id.error_without_system_provider'),
                      );
                    }

                    return callback();
                  },
                },
              ],
            })(
              <Input
                placeholder={t('cms.landlord.detail.system_external_id.placeholder')}
                disabled={landlord.systemExternalId}
              />,
            )}
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
EditLandlordIntegration.propTypes = {
  form: PropTypes.object.isRequired,
  landlord: PropTypes.object.isRequired,
  getLandlord: PropTypes.func.isRequired,
  updateLandlord: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default Form.create()(EditLandlordIntegration);
